import { SvgSprite } from './modules/svg-loader';


new SvgSprite('/img/sprite.svg');


